import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export const ButtonBack: React.FC = () => {
  const history = useNavigate();

  return (
    <button
      type="button"
      className="button_back"
      onClick={() => history(-1)}
    >
      <button id="buttonBack" type="button">
        <svg
          width="6"
          height="10"
          viewBox="0 0 6 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47124 0.528606C5.21089 0.268256 4.78878 0.268256
            4.52843 0.528606L0.528433 4.52861C0.268083 4.78896 0.268083
            5.21107 0.528433 5.47141L4.52843 9.47141C4.78878 9.73176
            5.21089 9.73176 5.47124 9.47141C5.73159 9.21107 5.73159 8.78896
            5.47124 8.52861L1.94265 5.00001L5.47124 1.47141C5.73159 1.21107
            5.73159 0.788955 5.47124 0.528606Z"
            fill="#313237"
          />
        </svg>
      </button>
      <h5><label htmlFor="buttonBack">Back</label></h5>
    </button>
  );
};
